import { DefaultError, useInfiniteQuery } from '@tanstack/react-query';
import { useInfiniteHandler } from 'hooks';
import { IContractProduct } from 'services/contract/types';
import { IInfinitePageParams, IInfinitePageResponse } from 'services/types';
import { apiClient } from 'utils';
import { getDefaultInfinitePageParam } from 'utils/service/defaultInfinitePageParam';
import { useResponseHandler } from 'utils/service/responseHandler';


export const useGetTrackProductsInfinite = (
  id: string,
  params?: IInfinitePageParams
) => {
  const { responseHandler } = useResponseHandler();
  const { getNextPageParam, infiniteHandler } = useInfiniteHandler();

  const { itemCount, page } = getDefaultInfinitePageParam(
    params?.page,
    params?.itemCount
  );

  return useInfiniteQuery<IContractProduct[], DefaultError>({
    queryKey: ['artist-products-infinite', id, params],
    queryFn: async ({ pageParam }) => {
      const response = await apiClient({
        method: 'GET',
        url: 'Track/Products',
        params: {
          TrackId: id,
          //   ...JSON.parse(JSON.stringify(params)),
          ...params,
          itemCount,
          page: pageParam,
        },
      });

      const value = await responseHandler<
        IInfinitePageResponse<IContractProduct>
      >(response, {
        groupName: `useGetTrackProductsInfinite - ${pageParam}`,
      });

      return infiniteHandler<IContractProduct>(value);
    },
    initialPageParam: page,
    getNextPageParam: getNextPageParam,
    // enabled: !!id
    retry: false,
  });
};

